import { Box, Text } from "@chakra-ui/react";
import { Color } from "theme/old-design-system/styled-components";
import { CustomFieldKey } from "entities/domain/templates";
import React from "react";

interface CustomFieldsInterface {
  onClick: () => void;
  fieldValue: string;
  fieldKey: CustomFieldKey | string;
}

const CustomField = ({
  onClick,
  fieldValue,
  fieldKey,
}: CustomFieldsInterface) => {
  return (
    <Box
      key={fieldKey}
      role="button"
      onClick={onClick}
      cursor="pointer"
      bgColor={`${Color.SECONDARY_GREEN.value}`}
      color="white"
      my="1px"
      mx="1px"
      px="0.35rem"
      py="0.1rem"
      borderRadius="4px"
      display="inline-block"
      _hover={{
        opacity: 0.8,
      }}
    >
      <Text
        as="span"
        data-custom-field-key={fieldKey}
        bgColor={Color.SECONDARY_GREEN.value}
      >
        {fieldValue}
      </Text>
    </Box>
  );
};

export default CustomField;
